import { render, staticRenderFns } from "./dataProcessing.vue?vue&type=template&id=637957cf&scoped=true"
import script from "./dataProcessing.vue?vue&type=script&lang=js"
export * from "./dataProcessing.vue?vue&type=script&lang=js"
import style0 from "./dataProcessing.vue?vue&type=style&index=0&id=637957cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637957cf",
  null
  
)

export default component.exports